import {HttpClient} from '@angular/common/http';
import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from '@ngx-ivengi/authentication';
import {AppConfig} from '../config/app.config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  public type;
  public data: {[key: string]: any};
  public isLoaded: boolean = false;

  public collapse1: boolean = false;
  public collapse2: boolean = true;
  public collapse3: boolean = true;
  public collapse4: boolean = true;
  public collapse5: boolean = true;

  constructor(
    @Inject(AppConfig) private appConfig,
    private http: HttpClient,
    private authService: AuthenticationService
  ) {}

  public ngOnInit(): void {
    this.type = (this.authService.getAuthorizationScopesSync().indexOf('dashboard:EMPLOYEE') !== -1) ? 'EMPLOYEE' : 'CLIENT';
    this.http.get(`${this.appConfig.apiUrl}/dashboard`).subscribe((data) => {
      this.data = data;
      this.isLoaded = true;
    });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/dashboard/dashboard.component.ts